module.exports = __webpack_public_path__ + "assets/drag-scene-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/drag-scene-icon.svg
// module id = 327
// module chunks = 0